import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Alert, Button, Field, Input, Select } from '@itds/elements/index.js';

import { STATES } from '@itds/Constants';

import Api from '@brokerage/utils/Api';

const General = ({ loadMember, member, setErrorMessage, setSuccessMessage }) => {
  const [data, setData] = useState({
    email: member.email,
    first_name: member.first_name,
    middle_name: member.middle_name,
    last_name: member.last_name,
    phone: member.phone,
    gender: member.gender,
    street1: member.street1,
    street2: member.street2,
    city: member.city,
    state: member.state,
    zip_code: member.zip_code,
    insurance_license_number: member.insurance_license_number,
    insurance_license_state: member.insurance_license_state,
    protective_contract_number: member.protective_contract_number,
    notes: member.notes || ''
  });
  const [show_success, toggleSuccess] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleFieldChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleUnlock = () => {
    window.scrollTo(0, 0);

    Api.unlockMember(member.id)
      .then(() => {
        loadMember();
        setSuccessMessage('Member account unlocked');
        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setErrorMessage('There was an error unlocking the Member account');
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  const handleSave = () => {
    const errors = [];

    ['email', 'first_name', 'last_name', 'phone', 'state'].forEach(name => {
      if (!data[name]) {
        errors.push(name);
      }
    });

    if (errors.length) {
      setErrors(errors);
    } else {
      setErrors(errors);

      Api.updateMember(member.id, data).then(() => {
        window.scrollTo(0, 0);

        toggleSuccess(true);

        setTimeout(() => {
          toggleSuccess(false);
        }, 2000);
      });
    }
  };

  return (
    <div>
      {show_success ? <Alert type='success'>Member Successfully Saved</Alert> : null}

      <Field label='Email'>
        <Input
          invalid={errors.includes('email')}
          onChange={handleFieldChange.bind(null, 'email')}
          required={true}
          value={data.email}
        />
      </Field>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Field label='First Name' style={{ flex: 1 }}>
          <Input
            invalid={errors.includes('first_name')}
            onChange={handleFieldChange.bind(null, 'first_name')}
            required={true}
            value={data.first_name}
          />
        </Field>

        <Field label='Middle Name' style={{ width: 300, margin: '0 10px' }}>
          <Input onChange={handleFieldChange.bind(null, 'middle_name')} value={data.middle_name} />
        </Field>

        <Field label='Last Name' style={{ flex: 1 }}>
          <Input
            invalid={errors.includes('last_name')}
            onChange={handleFieldChange.bind(null, 'last_name')}
            required={true}
            value={data.last_name}
          />
        </Field>
      </div>

      <Field label='Phone Number'>
        <Input
          invalid={errors.includes('phone')}
          onChange={handleFieldChange.bind(null, 'phone')}
          required={true}
          type='phone'
          value={data.phone}
        />
      </Field>

      <Field label='Gender'>
        <Select
          onChange={handleFieldChange.bind(null, 'gender')}
          options={[{ value: 'Male' }, { value: 'Female' }]}
          value={data.gender}
        />
      </Field>

      <Field label='Address Line 1'>
        <Input onChange={handleFieldChange.bind(null, 'street1')} value={data.street1} />
      </Field>

      <Field label='Address Line 2'>
        <Input onChange={handleFieldChange.bind(null, 'street2')} value={data.street2} />
      </Field>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Field label='City' style={{ flex: 1 }}>
          <Input onChange={handleFieldChange.bind(null, 'city')} value={data.city} />
        </Field>

        <Field label='State' style={{ width: 200, margin: '0 10px' }}>
          <Select
            invalid={errors.includes('state')}
            onChange={handleFieldChange.bind(null, 'state')}
            options={[{ value: '', label: '-- Select One --' }].concat(STATES)}
            required={true}
            value={data.state}
          />
        </Field>

        <Field label='Zip Code' style={{ width: 200 }}>
          <Input onChange={handleFieldChange.bind(null, 'zip_code')} value={data.zip_code} />
        </Field>
      </div>

      <div style={{ display: 'flex' }}>
        <Field label='Insurance License Number' style={{ marginRight: 10, flex: 1 }}>
          <Input
            onChange={handleFieldChange.bind(null, 'insurance_license_number')}
            value={data.insurance_license_number}
          />
        </Field>

        <Field label='Insurance License State' style={{ flex: 1 }}>
          <Input
            onChange={handleFieldChange.bind(null, 'insurance_license_state')}
            value={data.insurance_license_state}
          />
        </Field>
      </div>

      <Field label='Protective Contract Number'>
        <Input
          onChange={handleFieldChange.bind(null, 'protective_contract_number')}
          value={data.protective_contract_number}
        />
      </Field>

      <Field label='Member Notes'>
        <Input
          height={200}
          onChange={handleFieldChange.bind(null, 'notes')}
          type='textarea'
          value={data.notes}
        />
      </Field>

      <div style={{ display: 'flex', marginTop: 40 }}>
        <Button onClick={handleSave} style={{ marginRight: 5 }}>
          Save Changes
        </Button>
        {member.is_locked ? (
          <Button color='SECONDARY' onClick={handleUnlock.bind(null)}>
            Unlock
          </Button>
        ) : null}
      </div>
    </div>
  );
};

General.propTypes = {
  loadMember: PropTypes.func,
  member: PropTypes.object,
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func
};

export default General;
